import { render, staticRenderFns } from "./ModalTaskGraph.vue?vue&type=template&id=64d3a481&lang=pug"
import script from "./ModalTaskGraph.vue?vue&type=script&lang=js"
export * from "./ModalTaskGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports